module.exports = __webpack_public_path__ + "392662c0175e5fc9215cff9d92a42dc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg-side.png
// module id = 1544
// module chunks = 0